export default __webpack_public_path__ + "ef59721ec3c74a489a4b80b9a62a54a0.png";